export const DEFAULT_CULTURE = "en";
export const DEFAULT_TERMINAL = "q.idobet.com";
export const twoLetterCultureMap: Record<string, string> = {
  en: "en-US",
  es: "es-ES",
  fr: "fr-FR",
  de: "de-DE",
  it: "it-IT",
  pt: "pt-PT",
  ru: "ru-RU",
  zh: "zh-CN",
  ja: "ja-JP",
  ar: "ar-SA",
  he: "he-IL",
  sw: "sw-KE",
  am: "am-ET",
  ny: "ny-MW",
};
export const DEFAULT_CULTURE_LOCALE = "en-US";
export const TOTAL_STAKE_KEYBOARD_ID = "combo";
